import asyncComponent from '../../components/AsyncComponent';

const Handbooks = asyncComponent(() => import('../../containers/Handbook/HandbookList'));

export default Handbooks;
